<template>
  <!-- TODO: make a dumb component -->
  <footer class="mpf-footer" role="contentinfo">
    <div v-if="!showFooterLinks" class="mpf-width-container">
      <div class="mpf-grid-row">
        <div class="mpf-u-margin-bottom-3 mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-bottom-1">Powered by</p>
          <span class="brand-logo brand-logo-medicus" aria-hidden="true"></span>
        </div>
        <div class="mpf-footer__meta mpf-grid-column-one-half">
          <p class="mpf-body-s mpf-u-margin-top-5 mpf-u-text-align-right">
            {{ tenantStore.tenant?.localOrganisation?.name }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="mpf-width-container">
      <div class="mpf-footer__meta">
        <h2 class="mpf-u-visually-hidden">Support links</h2>
        <ul class="mpf-footer__list">
          <li class="mpf-footer__list-item">
            <router-link class="mpf-footer__list-item-link" to="/page/information/privacy-notice"
              >Privacy notice</router-link
            >
          </li>
          <li class="mpf-footer__list-item">
            <router-link
              class="mpf-footer__list-item-link"
              to="/page/information/patient-terms-of-use"
              >Patient terms of use
            </router-link>
          </li>
          <li class="mpf-footer__list-item">
            <router-link
              class="mpf-footer__list-item-link"
              to="/page/information/accessibility-statement"
            >
              Accessibility statement
            </router-link>
          </li>
          <li class="mpf-footer__list-item">
            <router-link class="mpf-footer__list-item-link" to="/page/information/cookies-policy"
              >Cookies policy</router-link
            >
          </li>
        </ul>

        <p class="mpf-body-s">© NHS England</p>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
  withDefaults(defineProps<{ showFooterLinks: boolean }>(), { showFooterLinks: false });
  import { useTenantStore } from '../../stores/useTenantStore';
  const tenantStore = useTenantStore();
</script>
